// extracted by mini-css-extract-plugin
export default {"container":"ripple-loader_container__vmv8H","ldsRipple":"ripple-loader_ldsRipple__q7RSu","lds-ripple":"ripple-loader_lds-ripple__m-fcN"};